// extracted by mini-css-extract-plugin
export var errorsContainer = "_vr-1";
export var link = "_vr-0";